import React from "react";
import Form from "./Components/OrdenForm";
import PageHeader from "../general/PageHeader";

const CrearOrden = () => {
	return (
		<>
			<PageHeader title="Nueva Orden de Compra" hasButton={false}/>
			<Form ordenActual={{}} isEdit={false} />
		</>
	);
};

export default CrearOrden;
